// third-party dependencies
import { type Content } from '@ngneat/overview';
import { createAction, props } from '@ngrx/store';
import { type DefaultToastOptions } from '@ngxpert/hot-toast';

// fantaz dependencies
import { type SnackbarConfigParams } from '../service';

export const showSnackbar = createAction(
  '[Core/Snackbar] Show Snackbar',
  props<{ message: Content; config?: Partial<DefaultToastOptions> }>(),
);

export const showSnackbarError = createAction(
  '[Core/Snackbar] Show Snackbar Error',
  props<{ message: Content; config?: Partial<SnackbarConfigParams> }>(),
);

export const showSnackbarSuccess = createAction(
  '[Core/Snackbar] Show Snackbar Success',
  props<{ message: Content; config?: Partial<SnackbarConfigParams> }>(),
);

export const showSnackbarWarning = createAction(
  '[Core/Snackbar] Show Snackbar Warning',
  props<{ message: Content; config?: Partial<SnackbarConfigParams> }>(),
);

export const showSnackbarInfo = createAction(
  '[Core/Snackbar] Show Snackbar Info',
  props<{ message: Content; config?: Partial<SnackbarConfigParams> }>(),
);
